/**
 * Получение dom-элементов ввнутри карточки товара
 * @method
 */

export default (productNode, fieldSelector, single = false) => {
  if (single) {
    return productNode.querySelector(fieldSelector);
  }

  return Array.from(productNode.querySelectorAll(fieldSelector));
};
